import { Grid } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material";

import Modal from "../../../../../../../../../components/Generic/Modal";
import UITabMaterial from "../../../../../../../../../components/Generic/UITabMaterial";

export const ModalCustom = styled(Modal)(() => ({
  maxWidth: "676px",
}));

export const PortQuantityBadgeContainer = styled(Grid)(() => ({
  position: "relative",
  top: "24px",
  left: "8px",
}));

export const ModalSection = styled("section")(() => ({
  paddingTop: "1rem",
  width: "100%",
}));

export const CustomSection = styled("section")(() => ({
  paddingTop: "1rem",
  width: "100%",
}));

export const CustomUITab = styled(UITabMaterial)(() => ({
  padding: "0",
}));

const styles = makeStyles(() => ({
  modalTabBody: {
    borderRadius: "0 0 8px 8px",
    // TODO: JOAO uncomment this for kit update
    // borderLeft: "none !important",
    // borderRight: "none !important",
    // borderBottom: "none !important",
  },
  modalTabGrid: {
    padding: "0",
  },
}));

export default styles;
